"use client";

import { useEffect } from "react";
import { isChunkError, recoverOnce } from "@/lib/chunkRecovery";

/**
 * ChunkRecovery — глобальный сторож ChunkLoadError.
 *
 * Вешает window-listeners как можно раньше (монтируется до AppRoot).
 * Динамический импорт реджектит промис → unhandledrejection;
 * script onerror → error. Любой провал чанка → recoverOnce().
 * Рендерит null — только эффект.
 */
export function ChunkRecovery() {
  useEffect(() => {
    const onError = (e: ErrorEvent) => {
      if (isChunkError(e.error) || isChunkError({ message: e.message })) {
        void recoverOnce();
      }
    };
    const onRejection = (e: PromiseRejectionEvent) => {
      if (isChunkError(e.reason)) void recoverOnce();
    };
    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);
    return () => {
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);

  return null;
}
